import { ContentLayoutProps } from "./types";

import styles from "./AuthLayout.module.css";



const AuthLayout = ({ children, leftSide }: ContentLayoutProps) => {
  return (
    <div className={styles["auth__wrapper"]}>
      <section className={styles["auth__promo"]}>
        {leftSide ? leftSide : <div className={styles.auth__promo__wrapper}><img src="/dashboard.svg" alt="Promo dashboard" /></div>}
      </section>
      <section className={styles["auth__form"]}>
        <div className={styles["auth__form-card"]}>
          {children}
        </div>
      </section>
    </div>
  );
}

export default AuthLayout;